import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useDatabaseSafe } from '../../context/DatabaseContext';

/**
 * PermissionGuard — for slug-based routes inside DatabaseProvider context.
 * Checks the permission key against the current DB slug.
 */
export const PermissionGuard = ({ permKey, children }) => {
  const { isSysAdmin, hasPermission } = useAuth();
  const dbContext = useDatabaseSafe();
  const dbSlug = dbContext?.dbSlug || '';
  if (isSysAdmin || hasPermission(permKey, dbSlug)) return children;
  return <Navigate to="/access-denied" replace />;
};

/**
 * GlobalPermissionGuard — for slug-free routes (dev tools, etc.).
 * Checks if the permission key exists in the user's global permissions.
 */
export const GlobalPermissionGuard = ({ permKey, children }) => {
  const { isSysAdmin, hasPermission } = useAuth();
  if (isSysAdmin || hasPermission(permKey, 'global')) return children;
  return <Navigate to="/access-denied" replace />;
};

/**
 * SysAdminGuard — hardcoded SysAdmin check for /admin/* routes.
 * Never permission-key driven — ensures we can never lock ourselves out.
 */
export const SysAdminGuard = ({ children }) => {
  const { isSysAdmin } = useAuth();
  if (isSysAdmin) return children;
  return <Navigate to="/access-denied" replace />;
};
